import React, { MouseEventHandler, ReactNode, useRef, useState } from 'react';
import css from './tooltip-wrapper.module.scss';
import { ReactComponent as TooltipArrow } from 'src/assets/tooltip-arrow.svg';
import classNames from 'classnames';
import { useOutsideClickTracker } from 'src/hooks/shared-hooks';

interface TooltipWrapperProps {
  text: string;
  wrapper: (
    tooltip: ReactNode,
    onMouseEnter: MouseEventHandler<HTMLDivElement>,
    onMouseLeave: MouseEventHandler<HTMLDivElement>
  ) => ReactNode;
}

export default function TooltipWrapper({ text, wrapper }: Readonly<TooltipWrapperProps>) {
  const containerRef = useRef(null);
  const [hover, setHover] = useState(false);
  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  useOutsideClickTracker(containerRef, () => {
    if (!hover) return;

    setHover(false);
  });

  const tooltip = (
    <div className={classNames(css.tooltip, hover ? css.hover : '')} ref={containerRef}>
      <TooltipArrow />
      <label>{text}</label>
    </div>
  );

  return wrapper(tooltip, onMouseEnter, onMouseLeave);
}
